import React from "react";
import { Modal } from "react-bootstrap";

const OurExclusiveContactUsModal = ({
  showPromoContactModal,
  handleCloseContactUsModal,
  formData,
  setFormData,
  errorMessage,
  setErrorMessage,
  handleContactUs,
}) => {
  return (
    <Modal
      show={showPromoContactModal}
      onHide={handleCloseContactUsModal}
      backdrop="static"
      className="editproductModal"
    >
      <Modal.Header closeButton>
        <h4 className="modal-title common_heading">Contact Us</h4>
      </Modal.Header>
      <Modal.Body className="popup_body_scroll">
        <div className="form about_form">
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="required-label">Full Name</label>
                <input
                  className="form-control"
                  type="text"
                  name="Name"
                  placeholder="Name"
                  onChange={(e) => {
                    setFormData({ ...formData, Username: e.target.value });
                    setErrorMessage({ ...errorMessage, Username: "" });
                  }}
                  value={formData?.Username}
                />
              </div>
              {errorMessage?.Username && (
                <div className="validation-message">
                  {errorMessage?.Username}
                </div>
              )}
            </div>

            <div className="col-lg-12">
              <div className="form-group">
                <label className="required-label">Email</label>
                <input
                  className="form-control"
                  type="email"
                  name="Email"
                  placeholder="user@example.com"
                  onChange={(e) => {
                    setFormData({ ...formData, UserEmail: e.target.value });
                    setErrorMessage({ ...errorMessage, UserEmail: "" });
                  }}
                  value={formData?.UserEmail}
                />
              </div>
              {errorMessage?.UserEmail && (
                <div className="validation-message">
                  {errorMessage?.UserEmail}
                </div>
              )}
            </div>

            <div className="col-lg-12">
              <div className="form-group">
                <label className="required-label">Phone No</label>
                <input
                  className="form-control"
                  type="number"
                  name="PhoneNo"
                  maxLength="10"
                  placeholder="Your Phone Number"
                  onChange={(e) => {
                    setFormData({ ...formData, PhoneNumber: e.target.value });
                    setErrorMessage({ ...errorMessage, PhoneNumber: "" });
                  }}
                  value={formData?.PhoneNumber}
                />
              </div>
              {errorMessage?.PhoneNumber && (
                <div className="validation-message">
                  {errorMessage?.PhoneNumber}
                </div>
              )}
            </div>

            <div className="col-lg-12">
              <div className="form-group">
                <label className="required-label">Address</label>
                <input
                  className="form-control"
                  type="text"
                  name="Address"
                  placeholder="Your Address"
                  onChange={(e) => {
                    setFormData({ ...formData, Address: e.target.value });
                    setErrorMessage({ ...errorMessage, Address: "" });
                  }}
                  value={formData?.Address}
                />
              </div>
              {errorMessage?.Address && (
                <div className="validation-message">
                  {errorMessage?.Address}
                </div>
              )}
            </div>

            <div className="col-lg-12">
              <div className="form-group">
                <label className="required-label">Query</label>
                <textarea
                  id="w3review"
                  name="Description"
                  rows="4"
                  className="form-control"
                  onChange={(e) => {
                    setFormData({ ...formData, Query: e.target.value });
                    setErrorMessage({ ...errorMessage, Query: "" });
                  }}
                  value={formData?.Query}
                ></textarea>
              </div>
              {errorMessage?.Query && (
                <div className="validation-message">{errorMessage?.Query}</div>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="common_btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={() => {
            handleCloseContactUsModal();
            setFormData({
              Username: "",
              UserEmail: "",
              PhoneNumber: "",
              Address: "",
              Query: "",
              BannerId: "",
            });
            setErrorMessage({
              Username: "",
              UserEmail: "",
              PhoneNumber: "",
              Address: "",
              Query: "",
            });
          }}
        >
          Cancel
        </button>

        <button
          type="button"
          className="common_btn view-data-btn"
          onClick={handleContactUs}
        >
          Submit
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default OurExclusiveContactUsModal;
